/** A list reduced to what is worth rendering, plus what was left out. */
export interface BoundedItems {
  /** Unique entries, in first-seen order, capped at the requested limit. */
  shown: string[];
  /** How many unique entries the cap left out. */
  hiddenCount: number;
  /** How many duplicate entries were collapsed away. */
  duplicateCount: number;
}

/**
 * Dedupe and cap a list of strings for display.
 *
 * Two problems, one helper. The lists these previews render come straight from
 * model output, so they can be arbitrarily long — a proposal with thousands of
 * IDs makes an approval dialog unreviewable, which defeats the point of
 * showing it. And they can repeat, which would emit duplicate React keys on a
 * keyed render.
 *
 * Order is first-seen so the head of a capped list still matches the head of
 * the proposal.
 */
export function boundedItems(
  items: readonly string[],
  max: number,
): BoundedItems {
  const unique = [...new Set(items)];
  return {
    shown: unique.slice(0, max),
    hiddenCount: Math.max(unique.length - max, 0),
    duplicateCount: items.length - unique.length,
  };
}
